(function () {
  if (window.zeyaDeferredChatReady) return;
  window.zeyaDeferredChatReady = true;
  var started = false;
  var timer;
  var events = ['pointerdown', 'scroll', 'keydown'];
  function loadScript(url, attribute) {
    var script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.setAttribute(attribute, '');
    document.head.appendChild(script);
  }
  function start() {
    if (started) return;
    started = true;
    clearTimeout(timer);
    events.forEach(function (event) { window.removeEventListener(event, start); });
    loadScript('https://config.gorgias.chat/bundle-loader/shopify/5azrzk-qz.myshopify.com', 'data-gorgias-loader-chat');
    loadScript('https://content.9gtb.com/loader.js', 'data-gorgias-loader-convert');
  }
  events.forEach(function (event) { window.addEventListener(event, start, { passive: true }); });
  function idleStart() { timer = setTimeout(start, 8000); }
  if (document.readyState === 'complete') idleStart();
  else window.addEventListener('load', idleStart, { once: true });
})();
